import { configureStore } from "@reduxjs/toolkit";
import hotelDetailsReducer from "./slice/features/hotelDetailsSlice";
import userDetailsReducer from "./slice/features/authSlice";
import { hotelApi } from "../api/hotelApi";
import { cancellationPolicyApi } from "../api/fetchCancellationPolicy";
import bookingPreviewReducer from "./slice/features/bookingPreviewSlice"
const store = configureStore({
  reducer: {
    hotelDetails: hotelDetailsReducer,
    auth: userDetailsReducer,
    bookingPreview: bookingPreviewReducer,
    [hotelApi.reducerPath]: hotelApi.reducer, 
    [cancellationPolicyApi.reducerPath]: cancellationPolicyApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(hotelApi.middleware)
                          .concat(cancellationPolicyApi.middleware), 
});

export default store;
